// extracted by mini-css-extract-plugin
export default {"App":"App_App__B2Ebb","header":"App_header__fhC8n","logo":"App_logo__7Edbg","title":"App_title__YS7Xx","content":"App_content__wwONY","main":"App_main__nhgh3"};